export default "__VITE_ASSET__BbX0Ai4Y__"